// libraries.
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

// hooks.
import {
  getSelectedOption,
  getSuggestionOption,
} from "@domains/VIM/slices/vim.slice";
import { getPublicationPrice } from "@pages/InventoryPage/modules/InventorySummary/components/shared/utils/getPublicationPrice";
import { useGetLeadDetailInfo } from "@store/apiSlices/leadDetail/leadDetail.hooks";
import { useGetInventoryPropertyInfo } from "@store/apiSlices/inventoryPropertyInfo/inventoryPropertyInfo.hook";
import { useApplyRangeToPublicationPrice } from "@pages/InventoryPage/modules/InventorySummary/components/shared/hooks/applyRangeToPublicationPrice";

// utils.
import { formatPrice } from "@utils/formatPrice.utils";
import {
  calculatePercentageInPrice,
  percentageToApplyInRelatedPricesMX,
} from "@shared/DashboardComponentsSummary/components/utils";
import { VIMCard } from "@domains/VIM/VIMCard";

export const PublicationPriceMX = () => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const pricePublicationInput = watch("publicationPrice");
  const applyPercentageToPrices = watch("applyPercentageToPrices");
  const leader = watch("leader");

  const { applyRangeToPublicationPrice } = useApplyRangeToPublicationPrice();

  const { area } = useGetLeadDetailInfo();

  const selectedOptionMX = useSelector(getSelectedOption);
  const suggestionOptionMX = useSelector(getSuggestionOption);

  const { publicationPrice: defaultPublicationPrice } =
    useGetInventoryPropertyInfo();

  const basePublicationPrice = getPublicationPrice(
    defaultPublicationPrice,
    selectedOptionMX,
    suggestionOptionMX,
  );

  const isDisabled = Boolean(selectedOptionMX || suggestionOptionMX);
  const publicationPriceM2 =
    Number(pricePublicationInput ?? basePublicationPrice) / area;

  const publiPriceM2Formatted = formatPrice(publicationPriceM2) || 0;

  useEffect(() => {
    setValue("publicationPrice", basePublicationPrice);
  }, [basePublicationPrice, setValue]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between">
        <div>Precio Publicado</div>
        <input
          data-testid="publicationPriceInputMX"
          disabled={isDisabled}
          {...register("publicationPrice", {
            onChange: (e) => {
              if (applyPercentageToPrices) {
                const priceMin = calculatePercentageInPrice(
                  e.target.value,
                  false,
                  percentageToApplyInRelatedPricesMX,
                );
                setValue("minPublicationPrice", priceMin, {
                  shouldDirty: true,
                });
              }
            },
            validate: (value) =>
              applyRangeToPublicationPrice({
                defaultPrice: basePublicationPrice,
                leader,
                price: value,
              }),
            valueAsNumber: true,
          })}
          type="text"
          className="rounded-3 p-2"
        />
      </div>
      <div className="d-flex gap-2 align-items-center">
        <VIMCard />
        <div className="d-flex justify-content-end w-100">
          <small className="text-white">
            Valor por m²: {publiPriceM2Formatted}
          </small>
        </div>
      </div>
      {errors.publicationPrice && (
        <small className="d-flex justify-content-end text-danger fw-bold">
          {String(errors.publicationPrice.message)}
        </small>
      )}
    </>
  );
};
